import { useStore } from 'effector-react'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import {
  Form,
  balanceFormModel,
} from '~/entities/common/Balance/BalanceHistory'
import {
  balanceHistoryModel,
  BalanceUseFormWatchOptions,
} from '~/entities/common/Balance/BalanceHistory'
import {
  transactionBalanceTypeEnumLabels,
  transactionMoveFundsTypeEnumLabels,
  transactionPaymentTypeEnumLabels,
} from '~/shared/config/constants'
import {
  TransactionBalanceTypeEnum,
  TransactionMoveFundsTypeEnum,
  TransactionPaymentTypeEnum,
} from '~/shared/config/enums'
import { Breadcrumbs, BreadcrumbsList } from '~/shared/ui/Breadcrumbs'
import { Container, PageTitle } from '~/shared/ui/Layout'

type CreateTransactionProps = {
  moveFundsType: TransactionMoveFundsTypeEnum
  isReadOnlyDriver?: boolean
  isReadOnlyCar?: boolean
  defaultValues?: Partial<balanceFormModel.FormValues>
  formWatchOption?: BalanceUseFormWatchOptions
  breadcrumbs: BreadcrumbsList
  isCreating?: boolean
}

export function CreateTransaction({
  moveFundsType,
  isReadOnlyDriver,
  isReadOnlyCar,
  defaultValues,
  formWatchOption,
  breadcrumbs,
  isCreating,
}: CreateTransactionProps) {
  const { t } = useTranslation()
  const isSubmitting = useStore(balanceHistoryModel.createFx.pending)

  const mappedDefaultValues = useMemo(
    () => ({
      ...defaultValues,
      moveFundsType: {
        id: moveFundsType,
        label: transactionMoveFundsTypeEnumLabels[moveFundsType],
      },
      paymentType: {
        id: TransactionPaymentTypeEnum.NON_CASH,
        label:
          transactionPaymentTypeEnumLabels[TransactionPaymentTypeEnum.NON_CASH],
      },
      balanceType: {
        id: TransactionBalanceTypeEnum.MAIN,
        label:
          transactionBalanceTypeEnumLabels[TransactionBalanceTypeEnum.MAIN],
      },
    }),
    [defaultValues, moveFundsType],
  )

  return (
    <>
      <Container isHeader>
        <Breadcrumbs list={breadcrumbs} />
        <PageTitle>{t('transaction creation')}</PageTitle>
      </Container>
      <Form
        defaultValues={mappedDefaultValues}
        isReadOnlyDriver={isReadOnlyDriver}
        isReadOnlyCar={isReadOnlyCar}
        onSuccess={balanceHistoryModel.formSubmitted}
        formWatchOption={formWatchOption}
        isCreating={isCreating}
        isSubmitting={isSubmitting}
      />
    </>
  )
}
